import React from "react";

// CEA30 logo: speed chevron + motion lines, wordmark with "30" in accent blue.
export function Logo({ className = "", light = false, showText = true }) {
  const ink = light ? "#FFFFFF" : "#1E3A8A";
  const accent = "#2563EB";
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`} data-testid="cea30-logo">
      <svg width="34" height="34" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <g>
          <path d="M20 10 L34 24 L20 38" stroke={accent} strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
          <path d="M10 15 L20 24 L10 33" stroke={ink} strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" fill="none" opacity="0.9" />
          <line x1="2" y1="20" x2="10" y2="20" stroke={accent} strokeWidth="2.5" strokeLinecap="round" opacity="0.5" />
          <line x1="0" y1="27" x2="9" y2="27" stroke={accent} strokeWidth="2.5" strokeLinecap="round" opacity="0.8" />
        </g>
      </svg>
      {showText && (
        <span className="font-extrabold text-xl tracking-tight leading-none" style={{ color: ink }}>
          CEA<span style={{ color: accent }}>30</span>
        </span>
      )}
    </span>
  );
}
